module.exports = __webpack_public_path__ + "img/fpIcon.759e5387.png";